import { ModuleRegistry } from 'ag-grid-community';
import { EnterpriseCoreModule, LicenseManager } from 'ag-grid-enterprise';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import toastr from 'toastr';

import store from 'javascript/store';

import { App } from './App';
import { reportWebVitals } from './reportWebVitals';

// Imported AFTER store/App so the core store↔graphql modules initialize in their
// original order first. Importing this earlier pulls the auth/graphql chain in
// before store is initialized, causing a "Cannot access 'd' before initialization" TDZ crash.
// eslint-disable-next-line import/order
import { handleSwitcherTokenFromHash } from 'components/Switcher/handleSwitcherToken';

import './index.scss';

import 'lib/sentryInit';
import 'toastr/build/toastr.min.css';

toastr.options = {
  positionClass: 'toast-top-right',
  progressBar: true,
  closeButton: true,
};

global.toastr = toastr;

/**
 * AG-GRID ENTERPRISE , License key setup
 */
const licenseKey = process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE_KEY || '';
ModuleRegistry.registerModules([EnterpriseCoreModule]);
LicenseManager.setLicenseKey(licenseKey);

// Handle switcher token from hash fragment (app-switch redirect)
handleSwitcherTokenFromHash();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
